import { useCallback } from 'react';

import { trpc } from '../lib/trpc';
import { resolveCurrentClientType } from '../lib/clientType';

interface UsePasswordResetRequestOptions {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}

export function usePasswordResetRequest(options: UsePasswordResetRequestOptions = {}) {
  const mutation = trpc.user.requestPasswordReset.useMutation({
    onSuccess: options.onSuccess,
    onError: options.onError,
  });

  const requestPasswordReset = useCallback(
    async (email: string) => {
      await mutation.mutateAsync({
        email,
        clientType: resolveCurrentClientType(),
      });
    },
    [mutation],
  );

  return {
    requestPasswordReset,
    isSubmitting: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}

export type UsePasswordResetRequestReturn = ReturnType<typeof usePasswordResetRequest>;
